// extracted by mini-css-extract-plugin
module.exports = {"extraCopy":"Complete_extraCopy__2MAdU","title":"Complete_title__34zOW","icon":"Complete_icon__1RB3J","button":"Complete_button__9pZpo"};